var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["info-box", _vm.bgClass] }, [
    _c(
      "div",
      { class: ["info-box-icon", _vm.bgIconClass] },
      [_c("a-lte-icon", { attrs: { icon: _vm.icon } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "info-box-content" },
      [
        _vm.header
          ? _c("div", { staticClass: "info-box-text" }, [
              _vm._v(_vm._s(_vm.header))
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("default")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }